import { TSSessionResponse } from '../../ducks/auth';

const sessions: TSSessionResponse = {
  sessionToken: 'fec5b8de-5eee-43fa-8109-942e7fdf2aae',
  expiry: '2022-06-18T17:24:44.210Z',
  userId: '2ec352be-c858-4252-bfb7-23ab1808824f',
};

export default sessions;
